import {ReactElement} from "react";
import {RendererProps} from "../RendererProps";
import {ensureNotObject} from "../common";
import {reforecastStartMonthString} from "./common";
import * as common from "../styles/common.module.scss";

export function RenderUpdateManualProperty(props: RendererProps): ReactElement {
    const name = props.variables["name"];
    const monthIdx = props.variables["reforecastStartMonthIndex"];

    return <div>
        <div className={common.section}>{ensureNotObject(name)}</div>
        <div className={common.section}>{reforecastStartMonthString(monthIdx)}</div>
    </div>;
}